module.exports = __webpack_public_path__ + "static/media/medium.891648ac.svg";